"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MatchRoad_1 = __importDefault(require("@Components/MatchComponents/MatchRoad"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Button_1 = require("@Components/Buttons/Button");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const SubmitMatchPopup = (props) => {
    const { isLoading, onCancel, onConfirm } = props;
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    return (react_1.default.createElement(Popup_1.default, { onClose: onCancel },
        react_1.default.createElement("div", { className: "modal-content" },
            react_1.default.createElement("h2", null, "Are you sure you want to match to this work?"),
            react_1.default.createElement("p", null, "To complete this process, confirm below that you'd like to make this match."),
            react_1.default.createElement(MatchRoad_1.default, { step: 2 }),
            isLoading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement("div", { className: "button-row" },
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: "secondary", onClick: onCancel }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: "primary", disabled: userStore.isInternal, onClick: onConfirm }, "Confirm"))))));
};
exports.default = (0, mobx_react_1.observer)(SubmitMatchPopup);
